<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px"/>
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Leltár bizonylatok</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/stock-takings/stock-takings/add')"
            icon="el-icon-plus"
            v-can="'stocktaking.create'"
          >
            Új leltár
          </el-button>
          <el-button
            style="float: right; margin-top: -5px; margin-right: 5px;"
            size="small"
            @click="getEmptyStockTaking"
            icon="el-icon-document"
            v-can="'stocktaking.create'"
          >
            Üres leltárív
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="stockTaking/fetchAll"
          />
        </div>
        <stock-taking-list/>
        <template v-if="$route.meta.showAddStockTakingDialog">
          <stock-taking-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateStockTakingDialog">
          <stock-taking-dialog
            :stock-taking-id="$route.params.id"
            type="update"
          />
        </template>
        <template v-if="$route.meta.showStockTakingViewDialog">
          <stock-taking-dialog
            :stock-taking-id="$route.params.id"
            type="view"
          />
        </template>
        <el-dialog
          title="Üres leltárív nyomtatása"
          :visible.sync="dialogVisible"
          width="400px"
        >
          <div>Raktár</div>
          <el-select
            v-model="storageId"
            :loading="storageLoading"
            filterable
            style="width: 100%; margin-top: 5px;"
          >
            <el-option
              v-for="storage in storages"
              :key="storage.id"
              :label="storage.name"
              :value="storage.id"
            />
          </el-select>
          <div slot="footer" class="dialog-footer">
            <el-button
              icon="el-icon-printer"
              :loading="printLoader"
              :disabled="!storageId"
              @click="printEmptyStock"
            >
              Nyomtatás
            </el-button>
          </div>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import StockTakingList from '../../../components/processes/stockTakings/stockTakings/List';
import StockTakingDialog from '../../../components/processes/stockTakings/stockTakings/Dialog';
import Sidebar from '../../../components/processes/stockTakings/Sidebar';
import TableFilter from '../../../components/TableFilter';

export default {
  components: {
    StockTakingDialog,
    StockTakingList,
    TableFilter,
    Sidebar,
  },
  data() {
    return {
      loading: false,
      storageId: null,
      filterConfig: null,
      dialogVisible: null,
      emptyLoading: false,
      printLoader: false,
      storageLoading: false,
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async getEmptyStockTaking() {
      this.dialogVisible = true;
      this.storageId = null;
      if (!this.storages || !this.storages.length) {
        this.storageLoading = true;
        await this.$store.dispatch('storage/fetchAll');
        this.storageLoading = false;
      }
    },
    async printEmptyStock() {
      this.printLoader = true;
      const response = await axios.get('api/stock-takings/empty-receipt/storage/' + this.storageId, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
      this.printLoader = false;

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
      this.dialogVisible = false;
    },
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      let users = this.$store.getters['user/users'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'select',
          options: [
            {
              label: 'Teljesített',
              status: 'done'
            },
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: storages,
          name: 'storage_id',
          label: 'Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
        {
          type: 'dateRange',
          name: 'delivery_date',
          label: 'Teljesítési időszak',
        },
        {
          type: 'select',
          options: users,
          name: 'creator_user_id',
          label: 'Rögzítette',
          labelCallback: user => user && `${user.last_name} ${user.first_name}` || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
